import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=98fb0fd4&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=ts&"
export * from "./BaseCard.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=98fb0fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fb0fd4",
  null
  
)

export default component.exports